var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoiceOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2a1 1 0 011 1v18a1 1 0 11-2 0V3a1 1 0 011-1zM7 7a1 1 0 011 1v8a1 1 0 11-2 0V8a1 1 0 011-1zm10 0a1 1 0 011 1v8a1 1 0 11-2 0V8a1 1 0 011-1zM2 10a1 1 0 011 1v2a1 1 0 11-2 0v-2a1 1 0 011-1zm20 0a1 1 0 011 1v2a1 1 0 11-2 0v-2a1 1 0 011-1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceOutline);
export default __webpack_public_path__ + "269f7b76eb52e8bbd6d7b540317e687c.svg";
export { ForwardRef as ReactComponent };